module.exports = __webpack_public_path__ + "img/temperature.a9e1e6e0.svg";